import React from 'react';
import ResultsMessage from './ResultsMessage';
import { defineMessages, useIntl } from 'react-intl';
import { lighten } from '@mui/material';
import { SearchField } from '@lifeomic/chroma-react/components/SearchField';
import { SingleFhirSearchResult } from '../../../hooks/SearchService';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';

const messages = defineMessages({
  search: {
    id: 'moduleHeader.search',
    defaultMessage: 'Search',
  },
});

export const useStyles = makeStyles((theme: Theme) => ({
  headerBox: {
    background: lighten(theme.palette.black[50], 0.75),
    borderBottom: `solid ${theme.pxToRem(1)} ${theme.palette.divider}`,
    margin: theme.spacing(1, 1, 0),
    padding: theme.spacing(1.5, 2),
  },
  searchBar: {
    width: theme.pxToRem(300),
  },
  collapse: {
    flexShrink: 0,
  },
}));

export interface ModuleHeaderOwnProps {
  isFetching: boolean;
  searchResult?: Omit<SingleFhirSearchResult, 'resourceType'>;
  hasMoreToLoad: boolean;
  loadMore: () => Promise<void>;
  searchValue: string;
  onSearchChange: (searchValue: string) => void;
}

export type ModuleHeaderProps = ModuleHeaderOwnProps;

const ModuleHeader: React.FC<ModuleHeaderProps> = ({
  searchResult,
  isFetching,
  hasMoreToLoad,
  loadMore,
  searchValue,
  onSearchChange,
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <Box className={classes.headerBox} align="center" justify="space-between">
      <SearchField
        className={classes.searchBar}
        aria-label={formatMessage(messages.search)}
        disableClearOnSearch
        onClear={() => onSearchChange('')}
        onSearch={onSearchChange}
        placeholder={formatMessage(messages.search)}
        onChange={e => onSearchChange(e.target.value)}
        value={searchValue ?? ''}
        fullWidth
      />
      <ResultsMessage
        hasMoreToLoad={hasMoreToLoad}
        loadMore={loadMore}
        isFetching={isFetching}
        searchResult={searchResult}
      />
    </Box>
  );
};

export default React.memo(ModuleHeader);
